import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './Banner.module.scss';

const BannerContent = ({
  borderColor, children, color, extraContentClassName, iconColor, iconType,
  onClose, showCloseButton, singleColorCard, title
}) => (
  <div className={clsx(`${styles.banner} card`, {
    [`tw-border-2 tw-border-${borderColor}`]: !!borderColor
  })}
  >
    <div className={`${styles.lockIcon} ${styles[color]}`}>
      <i aria-hidden="true" className={`fa ${iconType} tw-text-${iconColor} mr5`} />
    </div>
    <div
      className={clsx(`${styles.content} ${extraContentClassName}`, {
        [styles[color]]: singleColorCard,
      })}
    >
      {title && <div className={styles.title}>{title}</div>}
      <div className="tw-leading-tight">
        {children}
      </div>
      {showCloseButton && (
        <button
          aria-label="Close banner"
          className={`${styles.closeButton} close`}
          type="button"
          onClick={onClose}
        >
          ✕
        </button>
      )}
    </div>
  </div>
);

BannerContent.propTypes = {
  borderColor: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  color: PropTypes.string.isRequired,
  extraContentClassName: PropTypes.string,
  iconColor: PropTypes.string,
  iconType: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool,
  singleColorCard: PropTypes.bool,
  title: PropTypes.string,
};

BannerContent.defaultProps = {
  borderColor: null,
  extraContentClassName: '',
  iconColor: 'white',
  onClose: () => {},
  showCloseButton: false,
  singleColorCard: false,
  title: '',
};

export default BannerContent;
